/**
 * Context panel styles - LAYOUT ONLY.
 * Colors and hover states are defined in createBrandedTheme.ts.
 */

import { SxProps, Theme } from '@mui/material';

export const contextPanelStyles: Record<string, SxProps<Theme>> = {
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    bgcolor: 'custom.backgroundAlt',
    pt: 2,
    px: 2,
    pb: 0,
    overflow: 'hidden',
    position: 'relative',
  },
  contextItemsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    flex: 1,
    overflowY: 'auto',
    pb: 2,
  },
  title: {
    mb: 2,
    fontWeight: 500,
    color: 'text.secondary',
  },
  checkbox: {
    color: 'primary.main',
    '&.Mui-checked': {
      color: 'primary.main',
    },
    '&.Mui-disabled': {
      color: 'text.disabled',
    },
  },
  contextItemContainer: {
    mb: '2px',
  },
  contextItemText: {
    fontSize: '14px',
    color: 'text.primary',
  },
  contextItemTextDisabled: {
    fontSize: '14px',
    color: 'text.disabled',
  },
  contextItemLabel: {
    alignItems: 'center',
    margin: 0,
    '& .MuiFormControlLabel-label': {
      paddingTop: '0px',
      paddingLeft: '4px',
    },
  },
  contextItemChildrenContainer: {
    ml: '24px',
  },
};
